// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"InstamotionCard_cardWrapper__b5KiC","imageContainer":"InstamotionCard_imageContainer__d_yge","contentContainer":"InstamotionCard_contentContainer__d9OW4"};